import { render, staticRenderFns } from "./mock-account-confirmation-form.vue?vue&type=template&id=88b7bbf6&scoped=true&"
import script from "./mock-account-confirmation-form.vue?vue&type=script&lang=js&"
export * from "./mock-account-confirmation-form.vue?vue&type=script&lang=js&"
import style0 from "./mock-account-confirmation-form.vue?vue&type=style&index=0&id=88b7bbf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b7bbf6",
  null
  
)

export default component.exports